// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3I0E7","fileBtn":"File_fileBtn__10FGr","closeBtn":"File_closeBtn__1oTWe","fileSelected":"File_fileSelected__3stn1","disabled":"File_disabled__2ey9e"};